<template>
    <div class="col-md-12">
        <div class="card card-container">
            <img id="profile-img"
                 src="//ssl.gstatic.com/accounts/ui/avatar_2x.png"
                 class="profile-img-card" />
            <Form @submit="handleLogin" :validation-schema="schema">
                <div class="form-group">
                    <label for="loginId">Id</label>
                    <Field name="loginId" type="text" class="form-control" />
                    <ErrorMessage name="loginId" class="error-feedback" />
                </div>
                <div class="form-group">
                    <label for="password">Password</label>
                    <Field name="password" type="password" class="form-control" />
                    <ErrorMessage name="password" class="error-feedback" />
                </div>
                &emsp;
                <div class="form-group">
                    <button class="btn btn-primary btn-block" :disabled="loading">
                        <span v-show="loading"
                              class="spinner-border spinner-border-sm"></span>
                        <span>Login</span>
                    </button>
                </div>

                <div class="form-group">
                    <div v-if="message" class="alert alert-danger" role="alert">
                        {{ message }}
                    </div>
                </div>
            </Form>
        </div>
    </div> 
</template>

<script>
    import { Form, Field, ErrorMessage } from "vee-validate";
    import * as yup from "yup";

    export default {
        name: "Login",
        components: {
            Form,
            Field,
            ErrorMessage,
        },
        data() {
            const schema = yup.object().shape({
                loginId: yup.string().required("Id is required!"),
                password: yup.string().required("Password is required!"),
            });

            return {
                loading: false,
                message: "",
                schema,
            };
        },
        computed: {
            loggedIn() {
                return this.$store.state.auth.status.loggedIn;
            },
        },
        created() {
            if (this.loggedIn) {
                this.$router.push("/home");
            }
        },
        methods: {
            handleLogin(user) {
                this.loading = true;

                this.$store.dispatch("auth/login", user).then(
                    () => {
                        this.$router.push("/home");
                    },
                    (error) => {
                        this.loading = false;
                        this.message =
                            (error.response &&
                                error.response.data &&
                                error.response.data.message) ||
                            error.message ||
                            error.toString();
                    }
                );
            },
        },
    };
</script>

<style scoped>
    .btn {
        position: relative;
        left: 77%;
    }

    .card-container {
        height: 490px;
        width: 300px;
    }
</style>